import {getAuthSettings} from "../api/auth";

const pluralize = (number, words) => number ? `${number} ${words[number % 10 === 1 && number % 100 !== 11 ? 0 : number % 10 >= 2 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20) ? 1 : 2]}` : ''

export async function getPass() {
    const data = (await getAuthSettings()).data
    const requirements = []
    if (data?.minLength) {
        requirements.push(`состоять из ${pluralize(data.minLength, ['символа', 'символов', 'символов'])}`)
    }
    const categories = []
    if (data?.categories?.digit > 0) {
        categories.push(pluralize(data.categories.digit, ['цифру', 'цифры', 'цифр']))
    }
    if (data?.categories?.upper > 0) {
        categories.push(pluralize(data.categories.upper, ['заглавную букву', 'заглавные буквы', 'заглавных букв']))
    }
    if (data?.categories?.lower > 0) {
        categories.push(pluralize(data.categories.lower, ['строчную букву', 'строчные буквы', 'строчных букв']))
    }
    if (data?.categories?.spec > 0) {
        categories.push(pluralize(data.categories.spec, ['спецсимвол', 'спецсимвола', 'спецсимволов']))
    }
    if (categories.length) {
        const categoriesText = categories.join(', ')//.replace(/,([^,]*)$/, ' и$1')
        requirements.push(`содержать ${categoriesText}`)
    }
    if (data?.noSimilarCombinations?.allow > 0) {
        requirements.push(`иметь не более ${pluralize(data.noSimilarCombinations.allow, ['одинакового символа', 'одинаковых символов', 'одинаковых символов'])} подряд`)
    }
    return {
        passTxt: requirements.length
            ? `Пароль должен ${requirements.join(', ').replace(/,([^,]*)$/, ' и$1')}.`
            : 'Требования к паролю не заданы.',
        data
    }
}

/*export async function getPassOld() {
        const res = await getAuthSettings()
        return {passTxt:`Пароль должен состоять минимум из ${res.data?.minLength} символов,
        содержать минимум ${res.data?.categories.digit} цифру, ${res.data?.categories.upper} заглавную букву, ${res.data?.categories.lower} строчную букву,
        ${res.data?.categories.spec} спецсимвол и не более ${res.data?.noSimilarCombinations.allow} одинаковых символа подряд.`, data: res.data}
    }*/

export async function validPass(password, settings) {
    if (!settings) return false;
    let limit = settings?.noSimilarCombinations.allow || 2
    return password.length < settings.minLength ||
        password.replace(/[^A-ZА-ЯЁ]+/g, '').length < settings.categories.upper ||
        password.replace(/[^a-zа-яё]+/g, '').length < settings.categories.lower ||
        password.replace(/[^0-9]+/g, '').length < settings.categories.digit ||
        password.replace(/[A-Za-zА-ЯЁа-яё0-9]+/gm, '').length < settings.categories.spec ||
        password.match(`(.)\\1{${limit},}`,'gm')
}
